import Abstract from './Abstract.es6';

export default class extends Abstract {
    constructor(Component) {
        super();
        this.Component = Component;
    }

    async render(product) {
        product.buttons     = '';
        product.layout      = 'normal';
        product.quickBuy    = this.Component.quickBuy;
        product.buttons     = product.filteredButtons ? product.filteredButtons.join() : this.Component.buttons.join();
        product.price       = product.type === 0 ? '' : product.priceFormatted;
        product.target      = product.target || '_self';
        product.image       = window.devicePixelRatio > 1 ? App.Interface.Images.getFormatPath(product.image, 'search') : App.Interface.Images.getFormatPath(product.image, 'box');
        product.description = this.Component.dynamically.indexOf('description') === -1 ? '' : product.subline; // works only with products
        product.alt         = [product.name, await _('ALT.BOX.IMAGE')].join(' ');
        return App.Template.parse('box', product);
    }
}
